<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


/* ===========================================================================
 * B2B Cart bridge — single source of truth across cart drawer, cart page
 * and checkout. Routes any Shopify.addItem / Shopify.getCart / Shopify
 * .removeItem / Shopify.changeItem call to dash.deltaclothing.com so
 * related-products, quick-shop, recommended sections, etc. all hit the
 * same DraftOrder the PDP uses. Without this, those legacy paths post
 * to /cart/add.js and create a parallel Shopify cart that never picks
 * up the customer's tier / special prices.
 * Loaded BEFORE global.js's Shopify.addItem definition by being placed
 * at the top of custom.js, then re-applied on DOMContentLoaded so it
 * survives global.js overwriting it.
 * ===========================================================================*/
(function () {
  var API_BASE = 'https://dash.deltaclothing.com';

  function customerGid() {
    var raw = (document.body && document.body.getAttribute('customer')) || '';
    return raw ? ('gid://shopify/Customer/' + raw) : '';
  }

  // Read the currently selected color & size from the PDP DOM. Necessary
  // for S&S products because Delta's Shopify variants are size-only —
  // color is picked via a swatch UI and lives only in the DOM until the
  // user adds the line to cart. Without this the server can't translate
  // (variant_id, color, size) into a B00060XXX SKU and the customer
  // tier price (e.g. Gildan 5000 S = $2.39) silently regresses to the
  // catalog list price.
  function readPdpSelection() {
    var props = {};
    try {
      var swatch = document.querySelector('.color-swatch.selected, .swatch__input--color:checked')
                || document.querySelector('[data-color][aria-checked="true"]');
      if (swatch) {
        var color = swatch.getAttribute('data-color')
                  || swatch.getAttribute('data-value')
                  || swatch.value;
        if (color) props.Color = color;
      }
      // Size can come from a <select>, a radio, or a depot Qty input nearby.
      var sizeEl = document.querySelector('select[name*="ize"], input[name*="ize"]:checked')
                || document.querySelector('[data-size][aria-checked="true"]');
      if (sizeEl) {
        var size = sizeEl.getAttribute('data-size') || sizeEl.value;
        if (size) props.Variant = size;
      }
    } catch (e) {}
    return props;
  }

  // Shopify.addItem signature: (variant_id, quantity, $target, callback, input)
  function addItemViaPanel(variant_id, quantity, $target, callback, input) {
    var cust = customerGid();
    if (!cust) {
      window.location.href = '/account/login';
      return;
    }
    var qty = parseInt(quantity, 10) || 1;
    // Halo can pass extra properties via the 5th argument (`input`).
    // Merge those with whatever PDP DOM tells us; explicit input wins.
    var props = readPdpSelection();
    if (input && input.properties && typeof input.properties === 'object') {
      Object.keys(input.properties).forEach(function (k) {
        var v = input.properties[k];
        if (v !== undefined && v !== null && v !== '') props[k] = String(v);
      });
    }
    var payload = {
      customer_id: cust,
      items: [{
        variant_id: 'gid://shopify/ProductVariant/' + String(variant_id).replace(/\D/g, ''),
        quantity: qty,
        // Server is the source of truth for price (tier / customer-special).
        // We send 0 so the panel applies its own pricing rules.
        price: 0,
        properties: props
      }]
    };
    return fetch(API_BASE + '/coupon', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true
    })
    .then(function (r) { return r.json(); })
    .then(function (resp) {
      try { if (typeof callback === 'function') callback(resp); } catch (e) {}
      try { window.dispatchEvent(new CustomEvent('dlc:cart-changed', { detail: resp })); } catch (e) {}
      return resp;
    })
    .catch(function (err) { console.error('[dlc] addItem failed', err); });
  }

  // Shopify.getCart signature: (callback)
  function getCartViaPanel(callback) {
    var cust = customerGid();
    if (!cust) {
      if (typeof callback === 'function') callback({ items: [], item_count: 0, total_price: 0, currency: 'USD' });
      return;
    }
    fetch(API_BASE + '/bag', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id: cust }),
      cache: 'no-store'
    })
    .then(function (r) { return r.json(); })
    .then(function (lines) {
      var arr = Array.isArray(lines) ? lines : [];
      // Translate to a Shopify-cart-shaped payload so legacy halo handlers
      // that expect cart.item_count, cart.items[].title etc. keep working.
      var items = arr.map(function (l) {
        return {
          id: l.variant_id || l.line_id,
          variant_id: l.variant_id,
          line_id: l.line_id,
          quantity: parseInt(l.quantity, 10) || 0,
          price: Math.round((parseFloat(l.price) || 0) * 100), // Shopify uses cents
          line_price: Math.round(((parseFloat(l.price) || 0) * (parseInt(l.quantity, 10) || 0)) * 100),
          title: l.title || '',
          product_title: l.title || '',
          variant_title: (l.custom && (l.custom.Variant || l.custom.Color)) || '',
          sku: l.sku || (l.custom && l.custom.SKU) || '',
          properties: l.custom || {},
          image: (l.product && l.product[0] && l.product[0].images && l.product[0].images[0] && l.product[0].images[0].originalSrc) || '',
          url: l.product && l.product[0] && l.product[0].handle ? ('/products/' + l.product[0].handle) : '#',
          invoice_url: l.invoiceUrl || '',
        };
      });
      var totalQty = items.reduce(function (a, b) { return a + b.quantity; }, 0);
      var totalCents = items.reduce(function (a, b) { return a + b.line_price; }, 0);
      if (typeof callback === 'function') {
        callback({
          items: items,
          item_count: totalQty,
          total_price: totalCents,
          currency: 'USD',
          // Surface the DraftOrder checkout URL so any caller can use it.
          checkout_url: items.length ? items[0].invoice_url : '',
        });
      }
    })
    .catch(function (err) {
      console.error('[dlc] getCart failed', err);
      if (typeof callback === 'function') callback({ items: [], item_count: 0, total_price: 0, currency: 'USD' });
    });
  }

  function removeItemViaPanel(line_id_or_variant_id, callback) {
    var cust = customerGid();
    if (!cust) return;
    fetch(API_BASE + '/remove', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id: cust, lineId: line_id_or_variant_id })
    })
    .then(function (r) { return r.json(); })
    .then(function (resp) {
      if (typeof callback === 'function') callback(resp);
      try { window.dispatchEvent(new CustomEvent('dlc:cart-changed', { detail: resp })); } catch (e) {}
    })
    .catch(function (err) { console.error('[dlc] removeItem failed', err); });
  }

  // Wipe every client-side trace of the cart. MUST be called whenever
  // the server-side cart goes empty (manual clear, draft completed at
  // checkout, etc.) — otherwise the FastBag/cart-page sessionStorage
  // cache (`__fastbag_cache_v2`) keeps painting the dead lines and
  // hides anything new the customer adds. Single source of truth.
  function wipeLocalCart() {
    try { sessionStorage.removeItem('__fastbag_cache_v2'); } catch (e) {}
    try {
      if (window.__dlc_bag && typeof window.__dlc_bag.setCache === 'function') {
        window.__dlc_bag.setCache([]);
      }
    } catch (e) {}
    try {
      var cust = (document.body && document.body.getAttribute('customer')) || '';
      if (cust) localStorage.setItem('bag_count_qty:' + cust, '0');
    } catch (e) {}
    var badge = document.querySelector('[data-cart-count]');
    if (badge) badge.textContent = '0';
  }
  window.__dlc_wipeLocalCart = wipeLocalCart;

  function clearCartViaPanel(callback) {
    var cust = customerGid();
    if (!cust) return;
    fetch(API_BASE + '/clear', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id: cust })
    })
    .then(function (r) { return r.json(); })
    .then(function (resp) {
      wipeLocalCart();
      if (typeof callback === 'function') callback(resp);
      try { window.dispatchEvent(new CustomEvent('dlc:cart-changed', { detail: resp })); } catch (e) {}
    })
    .catch(function (err) { console.error('[dlc] clear failed', err); });
  }

  // Detect the "I just came back from Shopify checkout" transition.
  // If the previous page was the hosted checkout (or a thank-you page)
  // we proactively re-fetch /bag and wipe the local cache so the
  // customer never sees the just-paid order still sitting in the cart.
  function checkPostCheckoutReturn() {
    try {
      var ref = String(document.referrer || '');
      var fromCheckout = /\/(checkout|checkouts|orders|thank[_-]?you)/i.test(ref);
      var hasOrderParam = /[?&](order_id|checkout|order_number|fulfillment_status)=/i.test(window.location.search || '');
      if (!fromCheckout && !hasOrderParam) return;
      // Force a fresh fetch; if the server now reports an empty/closed
      // draft, writeCache([]) will replace the stale sessionStorage.
      if (window.__dlc_bag && typeof window.__dlc_bag.load === 'function') {
        window.__dlc_bag.load(true).then(function (lines) {
          if (!Array.isArray(lines) || lines.length === 0) {
            wipeLocalCart();
            try { window.dispatchEvent(new CustomEvent('dlc:cart-changed', { detail: { count: 0, source: 'post-checkout-return' } })); } catch (e) {}
          }
        });
      } else {
        wipeLocalCart();
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkPostCheckoutReturn, { once: true });
  } else {
    setTimeout(checkPostCheckoutReturn, 0);
  }

  // Apply the override now and again after global.js loads (it overwrites
  // these on init). The second pass on DOMContentLoaded wins because
  // global.js runs synchronously when the <script> tag is parsed but
  // Shopify.* assignments happen at the bottom of that file — by the
  // time DOMContentLoaded fires, our override locks them in.
  function install() {
    window.Shopify = window.Shopify || {};
    window.Shopify.addItem    = addItemViaPanel;
    window.Shopify.getCart    = getCartViaPanel;
    window.Shopify.removeItem = removeItemViaPanel;
    window.Shopify.changeItem = function (variant_id, quantity, $target, callback) {
      // changeItem in halo is essentially "set quantity"; we map that to
      // /coupon which the panel treats as upsert when the line exists.
      return addItemViaPanel(variant_id, quantity, $target, callback);
    };
    window.Shopify.clearCart = clearCartViaPanel;
  }
  install();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install, { once: true });
  } else {
    setTimeout(install, 0);
  }

  // Re-fetch /bag_count whenever cart changes so the header badge stays
  // in sync without waiting for the next page load. Also force a fresh
  // /bag fetch so any sessionStorage cache is replaced with the
  // server's truth (this is what catches the "draft just became an
  // order" transition for tabs that didn't navigate through checkout).
  window.addEventListener('dlc:cart-changed', function () {
    if (typeof window.func_bag_count === 'function') {
      try { window.func_bag_count(); } catch (e) {}
    }
    try {
      if (window.__dlc_bag && typeof window.__dlc_bag.load === 'function') {
        window.__dlc_bag.load(true);
      }
    } catch (e) {}
  });
})();



  // --- Hızlı sayaç: TOPLAM ADET (quantity toplamı) ---
  function func_bag_count() {
    var customer = $("body").attr("customer");
    var $badge   = $("[data-cart-count]");
    if (!$badge.length) return;

    // Misafir için loader'ı kaldır; metin göstermeyelim
    if (!customer) {
      $badge.removeClass("is-loading").text("");
      return;
    }

    var cacheKey = "bag_count_qty:" + customer;

    // 1) Varsa localStorage değeriyle ANINDA göster (flicker yok)
    try {
      var cached = localStorage.getItem(cacheKey);
      if (cached !== null) {
        $badge.text(cached).removeClass("is-loading");
      } else {
        // cached yoksa küçük bir loader göster
        $badge.addClass("is-loading").text("");
      }
    } catch (e) {
      $badge.addClass("is-loading").text("");
    }

    // 2) Ağdan en güncel değer
    fetch('https://dash.deltaclothing.com/bag_count', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id: 'gid://shopify/Customer/' + customer })
    })
    .then(r => r.json())
    .then(data => {
      // İSTENEN: TOPLAM ADET
      var qty = Number(data.count || 0);

      $badge.text(qty).removeClass("is-loading");

      try { localStorage.setItem(cacheKey, String(qty)); } catch (e) {}
    })
    .catch(() => {
      // Hata durumunda loader'ı kapatıp değeri boş bırak ya da cached varsa dokunma
      $badge.removeClass("is-loading");
    });

    // 3) Sekmeler arası senkron (başka sekmede değişirse anında güncelle)
    window.addEventListener("storage", function(e) {
      if (e.key === cacheKey && e.newValue != null) {
        $badge.text(e.newValue).removeClass("is-loading");
      }
    }, { once: false });
  }

  // Sayfa açılır açılmaz çalıştır
  func_bag_count();

  // Sepete ekleme / çıkarma işlemleri yaptığın yerde (ör. /coupon, /remove sonrası)
  // dönen JSON içindeki "count" ile rozeti ANINDA güncelle:
  window.setBagCountFromResponse = function (respJson) {
    try {
      var customer = $("body").attr("customer");
      if (!customer) return;
      var qty = Number(respJson && (respJson.count || respJson.count === 0) ? respJson.count : null);
      if (isNaN(qty)) return;
      var $badge = $("[data-cart-count]");
      $badge.text(qty).removeClass("is-loading");
      localStorage.setItem("bag_count_qty:" + customer, String(qty));
    } catch (e) {}
  };





document.addEventListener('DOMContentLoaded', function() {
    const elements = document.querySelectorAll('.pattern');

    elements.forEach(function(element) {
        const bgColor = window.getComputedStyle(element).getPropertyValue('background-color');
        const bgImage = window.getComputedStyle(element).getPropertyValue('background-image');

        // Özel durum: Beyaz (#FFFFFF) veya açık renkli arka planlarda siyah yazı rengi
        if (bgColor === 'rgb(255, 255, 255)' || bgColor.includes('white')) {
            element.style.color = '#000';  // Beyaz arka planlar için siyah yazı rengi
        }
        // "Natural" rengi için manuel kontrol (arka plan resmini de kontrol et)
        else if (bgImage.includes('natural.png') || bgColor === 'rgb(244, 231, 222)' || bgColor === '#F4E7DE') {
            element.style.color = '#000';  // "Natural" rengi için siyah yazı rengi
        }
        // "Heather Peach" için manuel kontrol
        else if (bgImage.includes('heather-peach.png')) {
            element.style.color = '#000';  // "Heather Peach" için siyah yazı rengi
        }
        // "Athletic Heather" için manuel kontrol
        else if (bgImage.includes('athletic-heather.png')) {
            element.style.color = '#000';  // "Athletic Heather" için siyah yazı rengi
        }
        // "Burnt Orange" için manuel kontrol
        else if (bgImage.includes('burnt-orange.png')) {
            element.style.color = '#000';  // "Burnt Orange" için siyah yazı rengi
        }
        // "Heather Dark Grey" için manuel kontrol
        else if (bgImage.includes('heather-dark-grey.png')) {
            element.style.color = '#fff';  // "Heather Dark Grey" için siyah yazı rengi
        }
        // "Heather Deep Teal" için manuel kontrol
        else if (bgImage.includes('heather-deep-teal.png')) {
            element.style.color = '#fff';  // "Heather Deep Teal" için siyah yazı rengi
        }
        // "Heather Navy" için manuel kontrol
        else if (bgImage.includes('heather-navy.png')) {
            element.style.color = '#fff';  // "Heather Navy" için siyah yazı rengi
        }
          // "Sport Grey" için manuel kontrol
        else if (bgImage.includes('sport-grey.png')) {
            element.style.color = '#000';  // "Sport Grey" için siyah yazı rengi
        }
          // "pink" için manuel kontrol
        else if (bgImage.includes('pink.png')) {
            element.style.color = '#000';  // "pink" için siyah yazı rengi
        }
          // "red" için manuel kontrol
        else if (bgImage.includes('red.png')) {
            element.style.color = '#fff';  // "red" için siyah yazı rengi
        }
          // "Heather Maroon" için manuel kontrol
        else if (bgImage.includes('heather-maroon.png')) {
            element.style.color = '#fff';  // "Heather Maroon" için siyah yazı rengi
        }
          // "Military Green" için manuel kontrol
        else if (bgImage.includes('military-green.png')) {
            element.style.color = '#fff';  // "Military Green" için siyah yazı rengi
        }
          // "Sand" için manuel kontrol
        else if (bgImage.includes('sand.png')) {
            element.style.color = '#000';  // "Sand" için siyah yazı rengi
        }
          // "Maroon" için manuel kontrol
        else if (bgImage.includes('maroon.png')) {
            element.style.color = '#fff';  // "Maroon" için siyah yazı rengi
        }
        // Diğer renkler için zıt renk hesaplama
        else {
            const rgb = bgColor.match(/\d+/g);
            if (rgb) {
                // Zıt rengi bulmak için RGB değerlerinin tersini alıyoruz
                const invertedColor = `rgb(${255 - parseInt(rgb[0])}, ${255 - parseInt(rgb[1])}, ${255 - parseInt(rgb[2])})`;
                element.style.color = invertedColor;
            } else {
                // Eğer arka plan rengi tanımlanamıyorsa varsayılan olarak siyah yap
                element.style.color = '#000';
            }
        }
    });
});





function getContrastTextColor(hex) {
    let r = parseInt(hex.substring(1, 3), 16);
    let g = parseInt(hex.substring(3, 5), 16);
    let b = parseInt(hex.substring(5, 7), 16);

    let yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return (yiq >= 128) ? '#000' : '#FFF';
}

function rgbToHex(rgb) {
    let result = rgb.match(/\d+/g);
    if (!result) return '#000000'; // Varsayılan siyah
    return `#${((1 << 24) + (parseInt(result[0]) << 16) + (parseInt(result[1]) << 8) + parseInt(result[2])).toString(16).slice(1).toUpperCase()}`;
}

function updateTextColors() {
    document.querySelectorAll('.color-swatch').forEach(el => {
        let bgColor = el.style.backgroundColor;

        if (!bgColor || bgColor === "transparent") return; // Geçersiz renkleri atla
        
        let hexColor = rgbToHex(bgColor);
        let textColor = getContrastTextColor(hexColor);

        el.querySelector('.color-name').style.color = textColor;
    });
}

// Sayfa yüklendiğinde ve her dinamik değişiklikte çalıştır
document.addEventListener("DOMContentLoaded", updateTextColors);

// Yeni eklenen elementleri de izlemek için MutationObserver kullan
// Yeni eklenen elementleri de izlemek için MutationObserver kullan
(function () {
    const dcColorObserver = new MutationObserver(updateTextColors);
    dcColorObserver.observe(document.body, { childList: true, subtree: true });
})();


(function () {
    const categoryBrandMap = [
        {
            category: 'Cap',
            entries: [
                { label: 'Flexfit', href: '/collections/flexfit' },
                { label: 'Valucap', href: '/collections/valucap' },
                { label: 'Richardson', href: '/collections/richardson' }
            ]
        },
        {
            category: 'Tote Bag',
            entries: [
                { label: 'Liberty Bags', href: '/collections/liberty-bags' }
            ]
        }
    ];

    function normalizeCategoryLabel(value) {
        return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
    }

    function createSidebarToggle() {
        const toggle = document.createElement('span');
        toggle.className = 'icon-dropdown';
        toggle.setAttribute('role', 'button');
        toggle.setAttribute('aria-label', 'Toggle submenu');
        toggle.setAttribute('tabindex', '0');
        toggle.innerHTML = '<span class="icon-plus"></span>';
        return toggle;
    }

    function createSidebarSubmenuItem(entry) {
        const item = document.createElement('li');
        item.className = 'navPage-subMenu-item';

        const link = document.createElement('a');
        link.className = 'navPage-subMenu-action link link-underline navPages-action';
        link.href = entry.href;
        link.setAttribute('aria-label', 'link');

        const text = document.createElement('span');
        text.className = 'text';
        text.textContent = entry.label;

        link.appendChild(text);
        item.appendChild(link);
        return item;
    }

    function ensureSidebarBrands() {
        if (!document.body.classList.contains('template-collection')) return;

        const sidebar = document.querySelector('#halo-sidebar .all-categories-list');
        if (!sidebar) return;

        const items = Array.from(sidebar.children).filter((child) => child.matches('li.navPages-item'));

        categoryBrandMap.forEach((config) => {
            const item = items.find((candidate) => {
                const label = candidate.querySelector('a.navPages-action > .text');
                return normalizeCategoryLabel(label && label.textContent) === normalizeCategoryLabel(config.category);
            });

            if (!item) return;

            const categoryLink = item.querySelector('a.navPages-action');
            if (categoryLink) {
                categoryLink.classList.add('has-subMenu');
            }

            let toggle = item.querySelector('.icon-dropdown');
            if (!toggle) {
                toggle = createSidebarToggle();
                if (categoryLink) {
                    categoryLink.insertAdjacentElement('afterend', toggle);
                } else {
                    item.appendChild(toggle);
                }
            }

            let submenu = item.querySelector('.dropdown-category-list');
            if (!submenu) {
                submenu = document.createElement('ul');
                submenu.className = 'dropdown-category-list navPages-level-2 list-unstyled';
                submenu.setAttribute('role', 'list');
                item.appendChild(submenu);
            }

            const existingEntries = new Set(
                Array.from(submenu.querySelectorAll('a')).map((anchor) => normalizeCategoryLabel(anchor.textContent))
            );

            config.entries.forEach((entry) => {
                if (existingEntries.has(normalizeCategoryLabel(entry.label))) return;
                submenu.appendChild(createSidebarSubmenuItem(entry));
            });

            if (item.classList.contains('current-cate')) {
                item.classList.add('is-clicked');
                submenu.style.display = 'block';
            }
        });
    }

    document.addEventListener('DOMContentLoaded', ensureSidebarBrands);
    window.addEventListener('load', ensureSidebarBrands);
})();


 
 
